import React from "react";
import "./contact.css";
import MapPoint from "../../assets/location.png";
import Phone from "../../assets/phone.png";
import EmailMe from "../../assets/email.png";
import emailjs from "emailjs-com";
// import Contact from "../../assets/contact.jpg"
const index = () => {
  function sendEmail(e) {
    e.preventDefault();

    emailjs
      .sendForm(
        "gmail",
        "template_tior6uf",
        e.target,
        "user_2wgBNLW9Ti9VLXJoFE88O"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  }
  return (
    <div className="contactContainer">
      <h2 className="contactusHeading">Contact Us</h2>
      <div className="titleUnderline"></div>
      <h1 className="contactusHeading2">Get In Touch</h1>
      <div className="formContainer">
        <form onSubmit={sendEmail}>
          <h2 className="myContact">My Contact</h2>
          <div className="formName">
            <input
              type="text"
              name="firstname"
              placeholder="First Name"
              required
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              required
            />
          </div>
          <div className="formEmailAddress">
            <input type="email" name="email" placeholder="Email" required />
            <input type="text" name="subject" placeholder="Subject" required />
          </div>
          <textarea
            name="message"
            textarea="true"
            placeholder="Message"
            className="messageBox"
            required
          ></textarea>
          <button type="submit" className="formBtn">
            Submit
          </button>
          <div className="iphonecircle"></div>
        </form>
      </div>
      <div className="contactInfo">
        <div className="location">
          <img src={MapPoint} alt="location" style={{ width: "48px" }} />
          <h2>Location</h2>
          <div className="contactUnderline"></div>
          <p>
            
              Biratnagar-5,Morang
              <br />
              Nepal
            
          </p>
        </div>
        <div className="contactNo">
          <img src={Phone} alt="contact no" style={{ width: "48px" }} />
          <h2>Contact No</h2>
          <div className="contactUnderline"></div>
          <p>
           
              +977-9863015749
              <br />
              +977-9811029863
            
          </p>
        </div>
        <div className="emailMe">
          <img src={EmailMe} alt="Email" style={{ width: "48px" }} />
          <h2>Email</h2>
          <div className="contactUnderline"></div>
          <p>
            
              nikeshpyakurel32@gmail.com
              <br />
              nikeshjava28@gmail.com
            
          </p>
        </div>
      </div>
    </div>
  );
};

export default index;
